import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider, RequireAuth } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MarketTicker from "./components/MarketTicker";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ArticlePage from "./pages/ArticlePage";
import ComunicazioniPage from "./pages/ComunicazioniPage";
import ComunicazioneDetailPage from "./pages/ComunicazioneDetailPage";
import SchedePage from "./pages/SchedePage";
import SearchPage from "./pages/SearchPage";
import Bilancio60Index from "./pages/Bilancio60Index";
import Bilancio60Detail from "./pages/Bilancio60Detail";
import TrasparenzaEGM from "./pages/TrasparenzaEGM";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <MarketTicker />
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-white min-h-screen flex flex-col">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminDashboard />
                </RequireAuth>
              }
            />

            {/* Public site */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/categoria/:slug" element={<PublicLayout><CategoryPage /></PublicLayout>} />
            <Route path="/articolo/:slug" element={<PublicLayout><ArticlePage /></PublicLayout>} />
            <Route path="/comunicazioni" element={<PublicLayout><ComunicazioniPage /></PublicLayout>} />
            <Route path="/comunicazioni/:sub" element={<PublicLayout><ComunicazioniPage /></PublicLayout>} />
            <Route path="/comunicazioni/:sub/:slug" element={<PublicLayout><ComunicazioneDetailPage /></PublicLayout>} />
            <Route path="/societa" element={<PublicLayout><SchedePage /></PublicLayout>} />
            <Route path="/bilancio-60-secondi" element={<PublicLayout><Bilancio60Index /></PublicLayout>} />
            <Route path="/bilancio-60-secondi/:ticker" element={<PublicLayout><Bilancio60Detail /></PublicLayout>} />
            <Route path="/trasparenza-egm" element={<PublicLayout><TrasparenzaEGM /></PublicLayout>} />
            <Route path="/cerca" element={<PublicLayout><SearchPage /></PublicLayout>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
